import { FC } from "react";
import { SanityMainImage } from "../../graphql-types";
import { cn } from "../lib/helpers";
import Image from "./Image";
import * as styles from "./ImageLockup.module.scss";

export interface ImageLockupProps {
  images: SanityMainImage[];
  className?: string;
}

const ImageLockup: FC<ImageLockupProps> = ({ images, className }) => {
  return (
    <div className={cn(styles.root, className)}>
      {images.map((image, index) => {
        return (
          <div key={index} className={styles.imageWrapper}>
            <Image image={image} className={styles.image} fullQuality />
          </div>
        );
      })}
    </div>
  );
};

export default ImageLockup;
